import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { SiteProvider, AuthProvider } from "./context/AppContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PublicPage from "./pages/PublicPage";
import { PromotionsPage, PromotionDetailPage } from "./pages/PromotionsPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import { AdminLogin, AdminResetPassword } from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function NotFound() {
  return (
    <main className="min-h-[60vh] flex items-center justify-center section-pad">
      <div className="text-center px-4">
        <h1 className="font-heading text-4xl text-[#0B1D3A] font-semibold">Page not found</h1>
        <p className="text-slate-500 mt-3">The page you're looking for doesn't exist.</p>
      </div>
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ duration: 1.2, smoothWheel: true }}>
        <SiteProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<PublicPage slug="home" />} />
                  <Route path="/about" element={<PublicPage slug="about" />} />
                  <Route path="/promotions" element={<PromotionsPage />} />
                  <Route path="/promotions/:id" element={<PromotionDetailPage />} />
                  <Route path="/plan-a-trip" element={<PublicPage slug="plan-a-trip" />} />
                  <Route path="/become-a-travel-agent" element={<PublicPage slug="become-a-travel-agent" />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                </Route>
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/reset-password" element={<AdminResetPassword />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route element={<PublicLayout />}>
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </SiteProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
